var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"__nuxt"}},[_c('div',{attrs:{"id":"__layout"}},[_c('div',{staticStyle:{"position":"relative"}},[_c('vueHeader',{attrs:{"long":_vm.long}}),_c('router-view',{attrs:{"long":_vm.long,"label":_vm.label}}),_c('vueFooter',{attrs:{"long":_vm.long,"link":_vm.link,"label":_vm.label}}),_c('vueRight',{attrs:{"label":_vm.label}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }